import { CommonRegData } from './common-reg-data';

export class BusinessRegData extends CommonRegData {
  name: string;
  email: string;

  constructor() {
    super();
  }
}



// WEBPACK FOOTER //
// ./app/states_mobile/auth/models/business-reg-data.ts